/**
 * useRenameCriativo — updates the `label` field on a `criativos` row
 * scoped to the current user.
 */
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useSupabaseClient } from "@/lib/supabase";
import { useProfileId } from "@/features/onboarding/hooks/useProfileId";

interface RenameCriativoInput {
  id: string;
  label: string;
}

export function useRenameCriativo() {
  const qc = useQueryClient();
  const { client } = useSupabaseClient();
  const { profileId } = useProfileId();

  return useMutation<void, Error, RenameCriativoInput>({
    mutationFn: async ({ id, label }) => {
      if (!profileId) throw new Error("Sessão não pronta. Tente novamente.");
      const { error } = await client
        .from("criativos")
        .update({ label })
        .eq("id", id)
        .eq("user_id", profileId);
      if (error) throw new Error(error.message);
    },
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ["criativos"] });
    },
  });
}
